import axios from "axios";
import i18n from "../../Languages/INEXT";
import { toast } from "react-toastify";


const axiosInstance = axios.create({
  baseURL: "https://api.sheelandmore.com.sa/public/api",
  timeout: 500000,
  headers: {
    Accept: "application/json",
    "Content-Type": "application/json",
  },
});



axiosInstance.interceptors.response.use(
  (response) => response,
  (error) => {
    if (error.response) {
      const status = error.response.status;
      
      if (status === 400) {
        toast.error("Bad Request");
      } else if (status === 404) {
        toast.error("Not Found");
      } else if (status === 422) {
        toast.error(error?.response?.data?.message || "Validation Error");
      } else if (status === 500) {
        toast.error("Server Error");
      } else if (status === 413) {
        toast.error("File size too large");
      } else {
        toast.error("An error occurred");
      }
      
    } else {
      toast.error("Network Error");
    }
    return Promise.reject(error);
  }
);

export default axiosInstance;
